import CopyIcon from "../../../components/Common/SvgIcons/TableIcons/CopyIcon";
import ViewIcon from "../../../components/Common/SvgIcons/TableIcons/ViewIcon";
import { createNewEvent } from "./createNewEvent";
import { tableColumnTypes } from "../../tableColumnTypes";
import Tooltip from "../../../components/Common/ToolTip/Tooltip";
import { FormattedMessage } from "react-intl";

export const eventPublishedByOthers = {
  label: <FormattedMessage id="MYCLASS_PUBLISHEDBYOTHERS" />,
  path: (tenantName) => `/${tenantName}/events/publishedByOthers`,
  searchPlaceHolder: "Search Published by Others by Event Name",
  columns: (navigate, tenantName) => [
    {
      ID: 1,
      name: <FormattedMessage id="EVENT_NAME_TEXT" />,
      fieldName: "Name",
      // value: (row) => row.Name,
      value: (row) => (
        <div title={row?.Name}>
          {row?.Name?.length > 25 ? row?.Name?.slice(0, 23) + "..." : row?.Name}
        </div>
      ),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="CREATED_BY" />,
      fieldName: "FirstName",
      value: (row) => row.FirstName + " " + row.LastName,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 3,
      name: <FormattedMessage id="MYCLASS_DATEMODIFY" />,
      fieldName: "ModifiedDate",
      value: (row) => row.ModifiedDate,
      sort: true,
      type: tableColumnTypes.DATE,
    },
    {
      ID: 4,
      name: <FormattedMessage id="MyClassStatus_lbl" />,
      fieldName: "StatusText",
      value: (row) => (row.PassCode ? <FormattedMessage id="Distributed_Text" /> : <FormattedMessage id="Published" />),
      sort: false,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 5,
      name: <FormattedMessage id="PASSCODE" />,
      fieldName: "PassCode",
      value: (row) => row.PassCode,
      sort: false,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 6,
      name: <FormattedMessage id="Cer_Actions" />,
      fieldName: "",
      value: (row) => (
        <>
          <Tooltip content={<FormattedMessage id="MYCLASS_COPY" />} direction={"bottom"}>
            <span
              onClick={() => {
                localStorage.setItem("shotclassTypeFrom", "publishedByOthers");
                navigate(`${createNewEvent.copypath(tenantName)}/${row.ID}`, {
                  state: { from: "publishedByOthers" },
                })
              }
              }
            >
              <CopyIcon />
            </span>
          </Tooltip>
          <Tooltip content={<FormattedMessage id="VIEW_SHOTCLASS" />} direction={"bottom"}>
            <span
              onClick={() => {
                localStorage.setItem("shotclassTypeFrom", "publishedByOthers");
                navigate(`${createNewEvent.viewpath(tenantName)}/${row.ID}`)
              }

              }
            >
              <ViewIcon />
            </span>
          </Tooltip>
        </>
      ),
      sort: false,
    },
  ],
};
